import React from 'react';
import {
  makeStyles, Box, Typography, useMediaQuery,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Certificate from './icons/Certificate';
import Laptop from './icons/Laptop';
import Exchange from './icons/Exchange';
import Support from './icons/Support';
import Briefcase from './icons/Briefcase';
import Investiment from './icons/Investiment';
import RocketIcon from './icons/RocketIcon';
import searchMony from '../../static/images/Search Money.png';
import calendar from '../../static/images/calendar.png';
import note from '../../static/images/note.png';
import tv from '../../static/images/TV.png';

const icons = {
  certificate: Certificate,
  laptop: Laptop,
  exchange: Exchange,
  support: Support,
  briefcase: Briefcase,
  investiment: Investiment,
  rocket: RocketIcon,
  note: searchMony,
  monitor: tv,
  calendar,
  dimondNote: note,
};

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '180px',
    height: '183px',
    background: '#FFFFFF',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05),  0px 8px 20px rgba(0, 0, 0, 0.08)',
    lineHeight: 1.1,

    '& .MuiTypography-root': {
      color: '#2E2E2E',
      lineHeight: 1.1,
      textAlign: 'center',
      flexWrap: 'nowrap',
      paddingBottom: '18px',
    },
  },
}));

export default function FeatureCard({
  keyIcon, title, foreground, color,
}) {
  const isMobileX = useMediaQuery('(max-width:390px)');

  const classes = useStyles();

  const Icon = icons[keyIcon];

  if (!Icon) { return null; }

  return (
    <Box className={classes.root}>
      <Box style={{
        height: '76px', marginTop: '23px', width: 'fit-content', marginBottom: '13px',
      }}
      >
        {(keyIcon !== 'note' && keyIcon !== 'monitor' && keyIcon !== 'calendar' && keyIcon !== 'dimondNote') && <Icon color={color} foreground={foreground} />}
        {(keyIcon === 'note' || keyIcon === 'monitor' || keyIcon === 'calendar' || keyIcon === 'dimondNote') && (
          <div style={{ width: 'fit-content', height: '68px' }}>
            <img src={Icon} alt={keyIcon} />
          </div>
        )}
      </Box>
      <Typography component="h3" style={{ padding: isMobileX ? '0 8px' : '0 16px', fontSize: isMobileX && '14px' }}>{title}</Typography>
    </Box>
  );
}

FeatureCard.propTypes = {
  keyIcon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  foreground: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};
